import * as PIXI from 'pixi.js';

import Tappable from './Tappable';

export default class TappableGraphicsButton extends Tappable {
    constructor(opts) {
        super(opts);

        const {
            text, width, height, padding = 0, backgroundColor = '#303a56', borderColor = '#4a5f82', fill = null,
            outerBorderColor, borderFill = null, outerBorderFill = null, borderWidth = 6, innerBorderWidth = borderWidth, outerBorderWidth = borderWidth, cornerRadius = 20, fontColor = '#ffffff', fontFill = null,
            fontSize = 35, fontFamily = 'Open Sans', fontWeight = 'bold', fontStrokeColor = '#000000', fontSpacing = 0,
            fontStrokeWidth = 0, contentOpacity = 1, icon = null, iconWidth = 0, iconHeight = 0, iconGap = 12, iconPosition = 'left', iconMode = 'float',
            shadowColor = null, shadowOffsetX = 0, shadowOffsetY = 0
        } = opts;

        const buttonText = new PIXI.Text({
            text,
            style: {
                fontFamily,
                fontSize,
                fill: fontFill ?? fontColor,
                fontWeight,
                letterSpacing: fontSpacing,
                stroke: { color: fontStrokeColor, width: fontStrokeWidth },
            },
        });
        const buttonWidth = width ?? buttonText.width + padding * 2;

        this.buttonWidth = buttonWidth;
        this.buttonHeight = height;
        this.cornerRadius = cornerRadius;
        this.backgroundColor = backgroundColor;
        this.borderColor = borderColor;
        this.borderWidth = borderWidth;
        this.innerBorderWidth = innerBorderWidth;
        this.outerBorderWidth = outerBorderWidth;
        this.outerBorderColor = outerBorderColor;
        this.borderFill = borderFill;
        this.outerBorderFill = outerBorderFill;
        this.fill = fill;
        this.shadowColor = shadowColor;
        this.shadowOffsetX = shadowOffsetX;
        this.shadowOffsetY = shadowOffsetY;

        this.layout = {
            width: buttonWidth,
            height: height,
        };

        this.onTap = () => {
            this.onButtonTap?.();
        };

        const scaleContainer = new PIXI.Container();
        scaleContainer.x = buttonWidth / 2;
        scaleContainer.y = height / 2;
        this.addChild(scaleContainer);

        this.onHoldStart = () => {
            scaleContainer.scale.set(0.9);
        };

        this.onHoldEnd = () => {
            scaleContainer.scale.set(1);
        };

        this.shadowGraphics = new PIXI.Graphics();
        this.graphics = new PIXI.Graphics();
        this.drawButton();
        scaleContainer.addChild(this.shadowGraphics);
        scaleContainer.addChild(this.graphics);
        this.addLabel(scaleContainer, {
            buttonText,
            contentOpacity,
            icon,
            iconWidth,
            iconHeight,
            iconGap,
            iconPosition,
            iconMode,
        });
    }

    addLabel(scaleContainer, { buttonText, contentOpacity, icon, iconWidth, iconHeight, iconGap, iconPosition, iconMode }) {
        const content = new PIXI.Container();
        content.alpha = contentOpacity;
        scaleContainer.addChild(content);

        if (!icon) {
            buttonText.anchor.set(0.5);
            content.addChild(buttonText);
            return;
        }

        const iconSprite = new PIXI.Sprite(icon);
        iconSprite.width = iconWidth;
        iconSprite.height = iconHeight;

        if (iconMode === 'float') {
            this.placeFloatingIcon(content, buttonText, iconSprite, iconGap, iconPosition);
            return;
        }

        this.placeInlineIcon(content, buttonText, iconSprite, iconWidth, iconGap, iconPosition);
    }

    placeFloatingIcon(scaleContainer, buttonText, iconSprite, iconGap, iconPosition) {
        const onRight = iconPosition === 'right';
        buttonText.anchor.set(0.5);
        iconSprite.anchor.set(onRight ? 1 : 0, 0.5);
        iconSprite.x = onRight
            ? this.buttonWidth / 2 - iconGap
            : -this.buttonWidth / 2 + iconGap;
        scaleContainer.addChild(buttonText);
        scaleContainer.addChild(iconSprite);
    }

    placeInlineIcon(scaleContainer, buttonText, iconSprite, iconWidth, iconGap, iconPosition) {
        const onRight = iconPosition === 'right';
        iconSprite.anchor.set(0, 0.5);
        buttonText.anchor.set(0, 0.5);

        const totalWidth = iconWidth + iconGap + buttonText.width;
        if (onRight) {
            buttonText.x = -totalWidth / 2;
            iconSprite.x = buttonText.x + buttonText.width + iconGap;
        } else {
            iconSprite.x = -totalWidth / 2;
            buttonText.x = iconSprite.x + iconWidth + iconGap;
        }

        scaleContainer.addChild(iconSprite);
        scaleContainer.addChild(buttonText);
    }

    drawButton() {
        const { buttonWidth, buttonHeight, cornerRadius, backgroundColor, borderColor, innerBorderWidth, outerBorderWidth, outerBorderColor, borderFill, outerBorderFill, shadowColor, shadowOffsetX, shadowOffsetY } = this;

        this.shadowGraphics.clear();
        if (shadowColor) {
            this.shadowGraphics.roundRect(-buttonWidth / 2 + shadowOffsetX, -buttonHeight / 2 + shadowOffsetY, buttonWidth, buttonHeight, cornerRadius);
            this.shadowGraphics.fill({ color: shadowColor });
        }

        this.graphics.clear();
        this.graphics.roundRect(-buttonWidth / 2, -buttonHeight / 2, buttonWidth, buttonHeight, cornerRadius);
        if (this.fill) {
            this.graphics.fill(this.fill);
        } else {
            this.graphics.fill({ color: backgroundColor });
        }
        if (borderFill) {
            this.graphics.stroke({ fill: borderFill, width: innerBorderWidth, alignment: 1 });
        } else {
            this.graphics.stroke({ color: borderColor, width: innerBorderWidth, alignment: 1 });
        }

        if (outerBorderFill || outerBorderColor) {
            this.graphics.roundRect(-buttonWidth / 2, -buttonHeight / 2, buttonWidth, buttonHeight, cornerRadius);
            if (outerBorderFill) {
                this.graphics.stroke({ fill: outerBorderFill, width: outerBorderWidth, alignment: 0 });
            } else {
                this.graphics.stroke({ color: outerBorderColor, width: outerBorderWidth, alignment: 0 });
            }
        }
    }

    setBorderColor(borderColor) {
        this.borderColor = borderColor;
        this.drawButton();
    }
}